import { render } from "./serverTalk.vue?vue&type=template&id=6ff69282"
import script from "./serverTalk.vue?vue&type=script&lang=js"
export * from "./serverTalk.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__